var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-Search';
                    var viewUrl = 'gfx/sprite.svg#view-icon-Search';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 28 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };